export default {
  namespaced: true,
  state: {
    /** @type {Collection} */
    list: {},
    listArr: [],
    /** @type {Option} */
    options: []
  },
  mutations: {
    setData(state, payload) {
      state.list = payload.list;
      state.options = payload.options;
      state.listArr = Object.keys(state.list)
        .map(Number)
        .sort((a, b) => a - b);
    }
  },
  actions: {
    async getCollections({ commit, state }) {
      const res = await this._vm.$http("get", "collections");
      if (res.status === 200) {
        const newData = { ...state };
        res.result.collections.forEach(item => {
          newData.list[item.id] = item;
        });

        commit("setData", newData);
      }

      return true;
    }
  },
  getters: {
  }
};
